import api from "./api";

const API_URL = "/Invoice";

const normalizeError = (err, action) => {
    if (err?.response) {
        const data = err.response.data;
        const message =
            data?.message ??
            data?.title ??
            (typeof data === "string" ? data : JSON.stringify(data)) ??
            `HTTP ${err.response.status}`;

        throw new Error(`${action} failed: ${message}`);
    }

    if (err?.request) {
        throw new Error(`${action} failed: no response from server`);
    }

    throw new Error(`${action} failed: ${err?.message || "Unknown error"}`);
};

export async function createInvoice(payload) {
    try {
        const r = await api.post(API_URL, payload);
        return r.data;
    } catch (err) {
        normalizeError(err, "Create invoice");
    }
}

export async function getInvoice(id) {
    try {
        const r = await api.get(`${API_URL}/${id}`);
        return r.data;
    } catch (err) {
        normalizeError(err, `Get invoice ${id}`);
    }
}

export async function listInvoices(page = 1, pageSize = 20) {
    try {
        const r = await api.get(API_URL, { params: { page, pageSize } });
        return r.data;
    } catch (err) {
        normalizeError(err, "List invoices");
    }
}

export async function myInvoices() {
    try {
        const r = await api.get(`${API_URL}/my`);
        return r.data;
    } catch (err) {
        normalizeError(err, "List my invoices");
    }
}

export async function getInvoicesForUser(userId) {
    try {
        const r = await api.get(`${API_URL}/user/${userId}`);
        return r.data;
    } catch (err) {
        normalizeError(err, "List invoices for user");
    }
}

export async function updateInvoice(payload) {
    try {
        const r = await api.put(API_URL, payload);
        return r.data;
    } catch (err) {
        normalizeError(err, "Update invoice");
    }
}

export async function markPaid(id) {
    try {
        await api.post(`${API_URL}/${id}/paid`);
    } catch (err) {
        normalizeError(err, `Mark invoice ${id} paid`);
    }
}

export async function cancelInvoice(id) {
    try {
        await api.post(`${API_URL}/${id}/cancel`);
    } catch (err) {
        normalizeError(err, `Cancel invoice ${id}`);
    }
}

export default {
    listInvoices,
    myInvoices,
    getInvoice,
    createInvoice,
    updateInvoice,
    getInvoicesForUser,
    markPaid,
    cancelInvoice,
};